import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { persistantLogin } from "../actions";
import { getLocalStorage } from "../common";
import { LoadingCard } from "../components";

class RedirectScreenBase extends React.Component {
    state = {
        checking: true
    };

    async componentDidMount() {
        try {
            if (!this.props.auth) {
                const loginDt = getLocalStorage("login_dt");

                if (loginDt != null) {
                    const _expire = Number(loginDt);
                    const _now = Number(Date.now());

                    if (_now < _expire) {
                        await this.props.persistantLogin();
                    }
                }
            }
        } finally {
            this.setState({ checking: false });
        }
    }

    render() {
        if (this.state.checking) {
            return <LoadingCard text="Loading your session..." />;
        }

        return this.props.auth ? (
            <Redirect to="/splash" />
        ) : (
            <Redirect
                to={{
                    pathname: "/login",
                    state: {
                        error: "You need to login first!"
                    }
                }}
            />
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth.auth
});

export const RedirectScreen = connect(mapStateToProps, { persistantLogin })(RedirectScreenBase);
export default RedirectScreen;
